import { useEffect, useRef } from 'react';

/**
 * Blocks browser back navigation on sensitive auth flows.
 * Works with BrowserRouter (useBlocker requires a data router).
 */
export function useAuthFlowBlocker(shouldBlock, message = 'You cannot go back to this step.') {
  const messageRef = useRef(message);
  messageRef.current = message;

  useEffect(() => {
    if (!shouldBlock) return;

    window.history.pushState({ authFlowBlock: true }, '');

    const onPopState = () => {
      const proceed = window.confirm(messageRef.current);
      if (proceed) {
        return;
      }
      window.history.pushState({ authFlowBlock: true }, '');
    };

    window.addEventListener('popstate', onPopState);
    return () => {
      window.removeEventListener('popstate', onPopState);
    };
  }, [shouldBlock]);
}
